import { useGSAP } from "@gsap/react";
import Card from "./Card";
import { useRef } from "react";
import gsap from 'gsap';
import { sortCards } from "../utility/cardUtils";

function Hand({ hand, playCard, isActive, animation, onAnimationComplete }) {
    const handRef = useRef();

    // if there is a draw animation, mark the last card with a property
    if (animation?.name === 'draw') {
        hand[hand.length - 1].isDrawn = true;
    }

    const sortedHand = sortCards(hand);

    // if innerwidth is smaller than the total cards,
    const gridTemplateColumns = `repeat(${hand.length},64px)`

    useGSAP(() => {
        if (!animation) return;

        switch (animation.name) {
            case 'fadeUp':
                gsap.fromTo(handRef.current.children, {
                    y: 0,
                }, {
                    y: -20,
                    ease: 'power1.in',
                    stagger: {
                        amount: 0.1,
                    },
                    duration: 0.333,
                });

                gsap.fromTo(handRef.current, {
                    opacity: 1,
                }, {
                    opacity: 0,
                    ease: 'power1.in',
                    duration: 0.333,
                    onComplete: () => {
                        onAnimationComplete({
                            name: 'fadeDown',
                            hand: animation.hand,
                        });
                    },
                });

                break;
            case 'fadeDown':
                gsap.fromTo(handRef.current.children, {
                    y: -20,
                }, {
                    y: 0,
                    ease: 'power1.out',
                    stagger: {
                        amount: 0.333
                    },
                });

                gsap.fromTo(handRef.current, {
                    opacity: 0,
                }, {
                    opacity: 1,
                    ease: 'power1.out',
                    duration: 0.333,
                    onComplete: () => {
                        onAnimationComplete({
                            name: null,
                        });
                        // kill the animation?
                    },
                });

                break;
            case 'cycle-left-out':
                gsap.fromTo(handRef.current, {
                    opacity: 1,
                    x: 0,
                }, {
                    opacity: 0,
                    x: -50,
                    ease: 'power1.in',
                    duration: 0.333,
                    onComplete: () => {
                        onAnimationComplete({
                            name: 'cycle-left-in',
                            hand: animation.hand,
                        });
                    },
                });
                break;
            case 'cycle-left-in':
                gsap.fromTo(handRef.current, {
                    opacity: 0,
                    x: 50,
                }, {
                    opacity: 1,
                    x: 0,
                    ease: 'power1.out',
                    duration: 0.333,
                    onComplete: () => {
                        onAnimationComplete({
                            name: null,
                        });
                    },
                });
                break;
            case 'cycle-right-out':
                gsap.fromTo(handRef.current, {
                    opacity: 1,
                    x: 0,
                }, {
                    opacity: 0,
                    x: 50,
                    ease: 'power1.in',
                    duration: 0.333,
                    onComplete: () => {
                        onAnimationComplete({
                            name: 'cycle-right-in',
                            hand: animation.hand,
                        });
                    },
                });
                break;
            case 'cycle-right-in':
                gsap.fromTo(handRef.current, {
                    opacity: 0,
                    x: -50,
                }, {
                    opacity: 1,
                    x: 0,
                    ease: 'power1.out',
                    duration: 0.333,
                    onComplete: () => {
                        onAnimationComplete({
                            name: null,
                        });
                    },
                });
                break;
            case 'draw':
                gsap.fromTo(handRef.current.querySelector('.new-card'), {
                    opacity: 0,
                    y: -40,
                }, {
                    opacity: 1,
                    y: 0,
                    ease: 'power1.out',
                    duration: 0.4,
                    onComplete: () => {
                        onAnimationComplete({
                            name: null,
                            effect: 'draw',
                        });
                    },
                });
                break;
            default:
                break;
        }
    }, [animation])

    return (
        <div className="scrollbar flex-grow text-center max-w-[90%] h-[254px] overflow-x-auto overflow-y-visible">
            <section ref={handRef} className={`inline-grid justify-center mr-16`} style={{ gridTemplateColumns: gridTemplateColumns }}>
                {sortedHand.map((card, index) => {
                    return (
                        <HandCard
                            key={'card_' + index}
                            index={index}
                            card={card}
                            playCard={() => playCard(card)}
                            active={isActive}
                            isNew={card.isDrawn}
                        />
                    );
                })}
            </section>
        </div>
    );
}

function HandCard({ card, playCard, active, index, isNew }) {
    return (
        <div onClick={playCard} className={`w-32 mt-10 hover:pt-10 hover:mt-0 group cursor-pointer z-[${index}] relative ${isNew ? 'new-card': ''}`} >
            <Card card={card} active={active} />
        </div>
    );
}

export default Hand;